export default [
  {
    path: '/payment-models',
    name: 'PagePaymentModelsList',
    meta: { title: 'paymentModels.listTitle', roles: ['ADMIN'] },
    component: () => import('@/pages/payment-models'),
  },
  {
    path: '/payment-models/:id/edit',
    name: 'PagePaymentModelsEdit',
    meta: { title: 'paymentModels.editFormTitle', roles: ['ADMIN'] },
    component: () => import('@/pages/payment-models/id/edit'),
  },
]
